import { z } from "zod";

/**
 * Schémas Zod pour les formulaires d'authentification (auth-page).
 *
 * Les messages d'erreur sont en français car ils sont remontés directement
 * dans <FormMessage /> et l'UI auth-page est déjà localisée FR par défaut.
 * Le contrat reste compatible avec useLoginMutation / useRegisterMutation
 * (cf. client/src/hooks/use-auth.tsx) qui postent username/password (+ fullName,
 * role, parish pour register) vers /api/login et /api/register.
 */

export const LoginFormSchema = z.object({
  username: z.string().min(1, "Identifiant requis"),
  password: z.string().min(1, "Mot de passe requis"),
});

export type LoginFormValues = z.infer<typeof LoginFormSchema>;

export const RegisterRoleEnum = z.enum([
  "cure",
  "vicaire",
  "econome",
  "secretaire_general",
  "secretaire",
  "responsable_mouvement",
  "conseiller",
  "benevole",
]);

export const RegisterFormSchema = z.object({
  fullName: z.string().min(1, "Nom complet requis"),
  username: z.string().min(1, "Identifiant requis"),
  password: z.string().min(6, "6 caractères minimum"),
  role: RegisterRoleEnum,
  parish: z.string().min(1, "Paroisse requise"),
});

export type RegisterFormValues = z.infer<typeof RegisterFormSchema>;
